import Alpine from 'alpinejs'

const projectSubmitManager = () => ({
  isFormDirty: false,
  isSubmitting: false,

  init() {
    window.addEventListener('form-dirty-changed', (e) => {
      this.isFormDirty = e.detail.isDirty
    })
  },

  async handleSubmit() {
    if (this.isSubmitting) return

    if (this.isFormDirty) {
      alert('目前分頁有未儲存的更動，請先儲存更動再進行提交')
      return
    }

    if (!confirm('確定要提交專案嗎？')) {
      return
    }

    this.submitProject()
  },

  async submitProject() {
    this.isSubmitting = true
    const submitUrl = this.$refs.submitContainer.dataset.submitUrl
    try {
      const response = await fetch(submitUrl, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html, text/html'
        }
      })

      if (response.ok) {
        window.location.reload()
      } else {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      alert('提交失敗，請稍後再試')
    } finally {
      this.isSubmitting = false
    }
  }
})

Alpine.data('projectSubmitManager', projectSubmitManager)
export default projectSubmitManager